<template>
	<v-container fluid fill-height>
		<Passagens @fechar="abrirPassagensPerfil = false" :abrir="abrirPassagensPerfil" :iniciado="iniciado.iniciado"/>		
		<Clas @fechar="abrirClasPerfil = false" :abrir="abrirClasPerfil" :iniciado="iniciado.iniciado"/>
		<Titulos @fechar="abrirTitulosPerfil = false" :abrir="abrirTitulosPerfil" :iniciado="iniciado.iniciado"/>		
		<v-row class="mx-auto">
			<v-col cols="12">
				<v-card class="d-none d-sm-flex flex-sm-column mx-auto" :loading="loading" max-width="1200">
					<v-card-text>
						<!-- menu lateral -->
						<v-tabs vertical class="ma-0">
							<!-- foto perfil -->
							<v-avatar class="mx-auto" color="grey" :size="tamanhoAvatar" tile>
								<v-img height="200" :src="iniciado.imagem"></v-img>
							</v-avatar>
							<input type="file" ref="file" @change="onFileSelected" style="display:none" />
							<v-btn small v-if="!salvarImagem" color="primary my-4" @click="launchFilePicker()">Alterar imagem</v-btn>
							<v-btn small v-if="salvarImagem" color="primary my-4" @click="uploadImg">Salvar imagem</v-btn>
							
							<!-- itens menu lateral -->
							<v-tab class="mt-4" @click.stop="mudarAba('dadosPessoais')">
								<v-icon left>mdi-account</v-icon>Dados Principais
							</v-tab>
							<v-tab @click.stop="mudarAba('endereco')">
								<v-icon left>mdi-account</v-icon>Endereço
							</v-tab>
							<v-tab @click.stop="mudarAba('outrosDados')">
								<v-icon left>mdi-account</v-icon>Outros Dados
							</v-tab>

							<!-- abas perfil -->
							<v-tab-item>
								<DadosPrincipais :dados="iniciado"/>
							</v-tab-item>
							<v-tab-item>
								<Endereco :dados="iniciado" />
							</v-tab-item>
							<v-tab-item>
								<OutrosDados :dados="iniciado"/>
							</v-tab-item>
						</v-tabs>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="py-0">
						<v-spacer></v-spacer>
						<v-btn small color="primary my-4" @click="abrirPassagens()">Ver Passagens</v-btn>
						<v-btn small color="primary my-4" @click="abrirClas()">Ver Clãs</v-btn>
						<v-btn small color="primary my-4" @click="abrirTitulos()">Ver Títulos</v-btn>
						<v-spacer></v-spacer>
						<v-spacer></v-spacer>
						<v-spacer></v-spacer>
						<v-spacer></v-spacer>
						<v-btn small color="primary" @click.stop="salvar()">Salvar</v-btn>
					</v-card-actions>
				</v-card>
				<v-card class="d-sm-none mx-auto">
					<v-card-text>
						<v-row class="justify-center">
							<v-col cols="12" class="d-flex">
								<v-avatar class="mx-auto" color="grey" :size="tamanhoAvatar" tile>
									<v-img height="200" :src="iniciado.imagem"></v-img>
								</v-avatar>
							</v-col>
						</v-row>
						<v-row class="justify-center">
							<v-col cols="12" class="d-flex">
								<input class="mx-auto" type="file" ref="file" @change="onFileSelected" style="display:none" />
								<v-btn class="mx-auto" small v-if="!salvarImagem" color="primary my-4" @click="launchFilePicker()">Alterar imagem</v-btn>
								<v-btn class="mx-auto" small v-if="salvarImagem" color="primary my-4" @click="uploadImg">Salvar imagem</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-tabs class="ma-0">
								<!-- itens menu lateral -->
								<v-tab class="mt-4" @click.stop="mudarAba('dadosPessoais')">
									<v-icon left>mdi-account</v-icon>Dados Principais
								</v-tab>
								<v-tab @click.stop="mudarAba('endereco')">
									<v-icon left>mdi-account</v-icon>Endereço
								</v-tab>
								<v-tab @click.stop="mudarAba('outrosDados')">
									<v-icon left>mdi-account</v-icon>Outros Dados
								</v-tab>

								<!-- abas perfil -->
								<v-tab-item>
									<DadosPrincipais :dados="iniciado"/>
								</v-tab-item>
								<v-tab-item>
									<Endereco :dados="iniciado" />
								</v-tab-item>
								<v-tab-item>
									<OutrosDados :dados="iniciado"/>
								</v-tab-item>
							</v-tabs>
						</v-row>
					</v-card-text>
					<v-card-actions class="py-0">
						<v-spacer></v-spacer>
						<v-btn small color="primary my-4" @click="abrirPassagens()">Ver Passagens</v-btn>
						<v-btn small color="primary my-4" @click="abrirClas()">Ver Clãs</v-btn>
						<v-btn small color="primary my-4" @click="abrirTitulos()">Ver Títulos</v-btn>
						<v-spacer></v-spacer>
						<v-spacer></v-spacer>
						<v-spacer></v-spacer>
						<v-spacer></v-spacer>
						<v-btn small color="primary" @click.stop="salvar()">Salvar</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>	
</template>

<script>

	import DadosPrincipais from '@/components/perfil/DadosPrincipais'
    import Endereco from '@/components/perfil/Endereco'
    import OutrosDados from '@/components/perfil/OutrosDados'
	import Passagens from '@/components/perfil/Passagens'
	import Titulos from '@/components/perfil/Titulos'
	import Clas from '@/components/perfil/Clas'
	import { baseApiUrl, showError, showSuccess } from "@/config/global"
	import axios from 'axios'
		
	import { mapState } from 'vuex'
	import metodos from '@/mixins/metodos'

	export default{
		name: 'Perfil',
		props:['perfis', 'status', 'paises'],
		computed:{
			... mapState(['user', 'buscandoDados', 'listaClas']),
			novoGrau(){
				return parseInt(this.ininiciado.dados.dados.grauAtual) + 1
			}
		},
		components: {
			DadosPrincipais,
			Endereco,
			OutrosDados,
			Passagens,
			Clas, 
			Titulos, 
		  },
		mixins:[metodos],
		data(){
			return{
				visivel: true,
				tamanhoAvatar: 164,
				abrirPassagensPerfil: false,
				abrirClasPerfil: false,
				abrirTitulosPerfil: false,
				cor: 'primary',
				aba: 'iniciado',
				abrirDataPicker: false,
				fotoSelecionada: null,
				salvarImagem: false,
				imageFile: null,
				imageUrl: null,
				iniciado: {},
				loading: false,
			}
		},
		methods:{
			uploadImg(){
				this.salvarImagem = false
				this.enviarImagem(this.imageFile, this.imageUrl)
			},
			launchFilePicker(){
				this.$refs.file.click()
				this.salvarImagem = true
			},
			
			onFileSelected(event){
				
				const {maxSize} = this
				this.imageFile = event.target.files[0]

					if(event.target.files.length > 0){
						let size = this.imageFile.size / maxSize / maxSize
						
						if(!this.imageFile.type.match('image.*')){
							this.errorDialog = true
							this.errorText = 'Please choose a image file'
						}else if( size > 1 ){
							this.errorDialog = true
							this.errorText = 'Your file is too big! Please select an image under 1MB'
						}else{
							
							//let formData = new FormData()
							this.imageUrl = URL.createObjectURL(this.imageFile)
							this.iniciado.imagem = this.imageUrl
							//formData.append('file', imageFile)

							//this.enviarImagem(formData, imageUrl)
						}
				}
			},

			enviarImagem(formData, imageUrl){
					
					const url = `${baseApiUrl}/iniciados/iniciado/insereImagem.php`
					
					//let arquivo = formData.get('file')
					let arquivo = this.imageFile
					let img64 = ""
					let inic = this.iniciado.iniciado
					 let reader = new FileReader()
					 reader.onloadend = function(){	
						
						img64 = reader.result

						axios.post(url, {imagem: img64, iniciado: inic})
						.then(res => {
							
							if(res.data.codigo == '01'){
							
								showSuccess(res.data.mensagem)
								this.salvarImagem = false
								// const obj = (JSON.parse(sessionStorage.getItem(userKey)))
								// obj.imagem = img64;
								
								// sessionStorage.setItem(userKey, JSON.stringify(obj))
							}else{
								showError(res.data.mensagem)
							}
						})


					 }

					 reader.readAsDataURL(arquivo)

					this.iniciado.imagem = imageUrl
			},

			fechar(){
				this.showPerfil = false
			},
			mudarAba(t){
				this.aba = t
			},
			converterData(dt){
				let data = new Date(dt)
				let difHorario = data.getTimezoneOffset() / 60
				data = new Date(data.setHours(data.getHours() + difHorario))
				return data
			},

			editarPerfil(){
               
			},

			mudarCla(){
				this.inserirHistoricoCla = true
			},

			passarGrau(){
				this.inserirNovoGrau = true
			},

			cadastrarNovoTitulo(){
				this.inserirTitulo = true
			},

			salvar(){
                this.loading = true
				const url = `${baseApiUrl}/iniciados/iniciado/update.php`
				axios.post(url, this.iniciado)
				.then(res => {
					if(res.data.codigo == '01'){
                        this.$store.commit('setUser', this.iniciado)
						showSuccess(res.data.mensagem)
					}

					this.loading = false
				})	
			},
            
			formataDateBr (dt) {
				if (!dt){
					return null
				} 
				const [year, month, day] = dt.split('-')
				const dataTxt = `${day}/${month}/${year}`
				return dataTxt
			},
			
			abrirPassagens(){
				this.abrirPassagensPerfil = true
			},

			abrirClas(){
				this.abrirClasPerfil = true
			},

			abrirTitulos(){
				this.abrirTitulosPerfil = true
			}
			
		},

		watch:{
			dataPassagem(){
				this.dataPassagemFormatada = this.formataDateBr(this.dataPassagem)
				this.itemPassagem.dataObj = this.converterData(this.dataPassagem)
			},
			
			dataHistorico(){
				this.dataHistoricoFormatada = this.formataDateBr(this.dataHistorico)
				this.itemHistoricoCla.dataObj = this.converterData(this.dataHistorico)
			},

			dataTitulo(){
				this.dataTituloFormatada = this.formataDateBr(this.dataTitulo)
				this.itemTitulo.dataObj = this.converterData(this.dataTitulo)
			}
		},

		created(){
			this.iniciado = this.user
		}
	}

</script>

<style scoped>

</style>